export default {
  FETCH_HOME_NUMBERS: 'FETCH_HOME_NUMBERS',
  FETCH_HOME_NUMBERS_SUCCESS: 'FETCH_HOME_NUMBERS_SUCCESS',
  FETCH_HOME_NUMBERS_FAILURE: 'FETCH_HOME_NUMBERS_FAILURE',

  RECALCULATE_HOME_NUMBERS: 'RECALCULATE_HOME_NUMBERS',
  RECALCULATE_HOME_NUMBERS_SUCCESS: 'RECALCULATE_HOME_NUMBERS_SUCCESS',
  RECALCULATE_HOME_NUMBERS_FAILURE: 'RECALCULATE_HOME_NUMBERS_FAILURE',
};
